import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles, renderBackground } from "../commonStyles.js";
const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;
export async function renderSectionWidget(context, widget, parent, override = null) {

    // <div class="widget section_widget">
    const el = context.document.createElement("div");
    el.classList.add("widget", "section_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...getSectionStyles(widget, breakpoint),
        ...getWrapperStyles(widget, breakpoint)
    };
    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);
    
    parent.appendChild(el);

    renderBackground(context, widget, el);

    // Render children
    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return el;

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, el);
    }

    return el;
}

function getSectionStyles(widget, breakpoint) {
    const styles = {};

    const props = widget?.properties?.[breakpoint];
    if (!props) return styles;

    const padding = props.padding ?? 0;

    styles.padding = `${padding}px`;
    // styles.width = "1200px";
    styles.display = 'flex';
    if (breakpoint === 'mobile'){
        styles['flex-direction'] = 'column';
    }

    return styles;
}

function getWrapperStyles(widget, breakpoint) {
    const styles = {};

    const props = widget?.properties?.[breakpoint];
    if (!props) return styles;

    const columnSpacing = props.columnSpacing ?? 0;

    if (columnSpacing > 0) {
        styles["border-spacing"] = `${columnSpacing}px 0px`;
        styles.margin = `0px -${columnSpacing}px`;
        styles.width = `calc(100% + ${columnSpacing * 2}px)`;
    }

    return styles;
}